import { render, staticRenderFns } from "./TicketDefectCard.vue?vue&type=template&id=7c297b42&"
import script from "./TicketDefectCard.vue?vue&type=script&lang=js&"
export * from "./TicketDefectCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports